import React from 'react';

import { Modal, message } from 'antd';

import fetch from '../../fetch';


/**
 * 文件下载
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const download = (url, params, fileName) => {
    return fetch.download(url, params, fileName)
}

const exist = (id) => {
    return fetch.post('ky/base/file/exist/'+ id)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

export default {
	download,
	exist
}